import { datConditons } from '../constants/dat-condition.constant';

/**
 * Ngưỡng quãng đường luật định của một khoá học.
 *
 * Cột "Tổng QĐ" hiện đang là một con số trần: `805,67 km`. Người đọc phải tự
 * nhớ hạng BSS cần 810 km, BTĐ cần 710, C1 cần 825 — ba con số khác nhau, trong
 * một bảng trộn lẫn nhiều khoá. Hiện `805,67 / 810` thì câu hỏi duy nhất của
 * mỗi dòng được trả lời ngay tại chỗ.
 *
 * Tách thành hàm thuần vì nó là chỗ dễ sai lặng lẽ: lấy nhầm ngưỡng thì ô vẫn
 * hiện một phân số trông hợp lý.
 */

/** 'BSS-K36' → 'BSS'. Trả về '' nếu không đọc được. */
export function hangTuKhoa(courseShortName) {
  return String(courseShortName || '').split('-')[0] || '';
}

/**
 * @returns {number|null} ngưỡng km, hoặc null khi không tra được hạng —
 *   người gọi phải hiện con số trần thay vì bịa ra một ngưỡng.
 */
export function nguongQuangDuong(courseShortName) {
  const hang = hangTuKhoa(courseShortName);
  const found = datConditons.find((e) => e.license === hang);
  return found ? found.totalQD : null;
}

/**
 * Trạng thái của một dòng so với ngưỡng.
 *
 * Chỉ ba giá trị, và chỉ hai trong số đó có màu:
 *   'dat'     — đủ km
 *   'thieu'   — chưa đủ
 *   'khong-ro'— không tra được ngưỡng, không tô màu gì cả
 *
 * Dùng `>=`: chạy đúng bằng ngưỡng là đạt, khớp với `checkDATConditions`.
 * Hai chỗ lệch nhau thì cột và dải chỉ tiêu sẽ nói hai điều khác nhau về cùng
 * một học viên.
 */
export function trangThaiQuangDuong(totalDistance, courseShortName) {
  const nguong = nguongQuangDuong(courseShortName);
  if (nguong == null) return 'khong-ro';
  return Number(totalDistance || 0) >= nguong ? 'dat' : 'thieu';
}
